import type { IconProps } from 'common-types';

const Close = ({ width = 24, height = 24, fill }: IconProps) => (
  <svg
    width={width}
    height={height}
    viewBox={`0 0 24 24`}
    fill={fill ?? 'none'}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.5866 11.9999L7.29357 8.70692C7.11141 8.51832 7.01062 8.26572 7.0129 8.00352C7.01517 7.74132 7.12034 7.49051 7.30575 7.3051C7.49116 7.11969 7.74197 7.01452 8.00417 7.01224C8.26637 7.00997 8.51897 7.11076 8.70757 7.29292L12.0006 10.5859L15.2936 7.29292C15.4822 7.11076 15.7348 7.00997 15.997 7.01224C16.2592 7.01452 16.51 7.11969 16.6954 7.3051C16.8808 7.49051 16.986 7.74132 16.9882 8.00352C16.9905 8.26572 16.8897 8.51832 16.7076 8.70692L13.4146 11.9999L16.7076 15.2929C16.8031 15.3852 16.8793 15.4955 16.9317 15.6175C16.9841 15.7395 17.0117 15.8707 17.0128 16.0035C17.014 16.1363 16.9887 16.268 16.9384 16.3909C16.8881 16.5138 16.8139 16.6254 16.72 16.7193C16.6261 16.8132 16.5144 16.8875 16.3915 16.9377C16.2686 16.988 16.1369 17.0133 16.0042 17.0122C15.8714 17.011 15.7402 16.9834 15.6182 16.931C15.4962 16.8786 15.3858 16.8024 15.2936 16.7069L12.0006 13.4139L8.70757 16.7069C8.61532 16.8024 8.50498 16.8786 8.38297 16.931C8.26097 16.9834 8.12975 17.011 7.99697 17.0122C7.86419 17.0133 7.73251 16.988 7.60962 16.9377C7.48672 16.8875 7.37507 16.8132 7.28117 16.7193C7.18728 16.6254 7.11303 16.5138 7.06275 16.3909C7.01247 16.268 6.98717 16.1363 6.98832 16.0035C6.98947 15.8707 7.01706 15.7395 7.06947 15.6175C7.12188 15.4955 7.19806 15.3852 7.29357 15.2929L10.5866 11.9999Z"
      fill={fill ?? '#14171A'}
    />
  </svg>
);

export default Close;
